import { getFiltersReducer } from 'common/store/reducers/filters';
import { combineReducers } from 'redux';
import { tagsFiltersActionTypes } from '../actions';
import list from './list';

export const tagsReducers = combineReducers({
  list,
  filters: getFiltersReducer(tagsFiltersActionTypes),
});
